import { render, staticRenderFns } from "./TrainingTemplate.vue?vue&type=template&id=91d31ae4&"
import script from "./TrainingTemplate.vue?vue&type=script&lang=js&"
export * from "./TrainingTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports